import { formatDate } from "@/util/parseTime";
import * as echarts from "echarts";
export function loadSqChart(myChart, obj, unit, dtype = "yyyy-MM-dd") {
  let data10 = [];
  let data20 = [];
  let data30 = [];
  let date = [];
  for (var i = 0; i < obj.length; i++) {
    let time1 = obj[i].date + ":00";
    let time = formatDate(new Date(time1), dtype);
    // var date = new Date(obj[i].date + ":00")
    // var time = date.getDay();
    date.push(time);
    data10.push(obj[i].value10);
    data20.push(obj[i].value20);
    data30.push(obj[i].value30);
  }
  myChart.setOption({
    legend: {
      show: true,
      icon: "circle",
      orient: "horizontal",
      top: "0%",
      right: "2%",
      itemWidth: 10,
      itemHeight: 8,
      itemGap: 5,
      textStyle: {
        // color: '#FFFFFF'
        color: "#fff",
        fontSize: 10
      }
    },

    tooltip: {
      trigger: "axis",
      axisPointer: {
        lineStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "rgba(0, 255, 233,0)"
              },
              {
                offset: 0.5,
                color: "rgba(255, 255, 255,1)"
              },
              {
                offset: 1,
                color: "rgba(0, 255, 233,0)"
              }
            ],
            global: false
          }
        }
      }
    },
    grid: {
      top: "20%",
      left: "5%",
      right: "5%",
      bottom: "18%",
      containLabel: true
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          show: true,
          color: "#fff"
        },
        splitArea: {
          // show: true,
          color: "#f00",
          lineStyle: {
            color: "#f00"
          }
        },
        axisLabel: {
          color: "#fff"
        },
        splitLine: {
          show: false
        },
        boundaryGap: false,
        data: date
      }
    ],

    yAxis: [
      {
        type: "value",
        name: unit,
        nameGap: 8,
        nameTextStyle: {
          color: "#fff"
        },
        min: function(value) {
          return value.min;
        },
        max: function(value) {
          return value.max;
        },
        // max: 30,
        // splitNumber: 4,
        splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(0, 144, 255,0.3)"
          }
          // lineStyle: {
          //   color: ["#fff"],
          //   opacity: 0.06
          // }
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: true,
          margin: 20,
          textStyle: {
            fontSize: 10,
            // color: "rgba(255,255,255,0.5)"
            color: "#fff"
          }
        },
        axisTick: {
          show: false
        }
      }
    ],
    series: [
      {
        name: "10CM",
        type: "line",
        smooth: true, //是否平滑
        showAllSymbol: true,
        // symbol: 'image://./static/images/guang-circle.png',
        symbol: "circle",
        symbolSize: 0,
        lineStyle: {
          normal: {
            color: "rgb(255,133,14)",
            shadowColor: "rgba(0, 0, 0, 0)",
            shadowBlur: 0,
            shadowOffsetY: 5,
            shadowOffsetX: 5
          }
        },
        label: {
          show: false,
          position: "top",
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        itemStyle: {
          color: "rgb(255,133,14)",
          borderColor: "rgb(0,115,100)",
          borderWidth: 0,
          shadowColor: "rgba(0, 0, 0, 0)",
          shadowBlur: 0,
          shadowOffsetY: 0,
          shadowOffsetX: 0
        },
        tooltip: {
          show: true
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(0, 144, 255, 0.3)"
                },
                {
                  offset: 1,
                  color: "rgba(0, 144, 255,0.1)"
                }
              ],
              false
            ),
            shadowColor: "rgba(0, 144, 255,0.1)",
            shadowBlur: 10
          }
        },
        data: data10
      },
      {
        name: "20CM",
        type: "line",
        smooth: true, //是否平滑
        showAllSymbol: true,
        // symbol: 'image://./static/images/guang-circle.png',
        symbol: "circle",
        symbolSize: 0,
        lineStyle: {
          normal: {
            color: "rgb(1,255,251)",
            shadowColor: "rgba(0, 0, 0, 0)",
            shadowBlur: 0,
            shadowOffsetY: 5,
            shadowOffsetX: 5
          }
        },
        label: {
          show: false,
          position: "top",
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        itemStyle: {
          color: "rgb(1,255,251)",
          borderColor: "rgb(255,115,100)",
          borderWidth: 0,
          shadowColor: "rgba(0, 0, 0, 0)",
          shadowBlur: 0,
          shadowOffsetY: 0,
          shadowOffsetX: 0
        },
        tooltip: {
          show: true
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(0, 144, 255, 0.3)"
                },
                {
                  offset: 1,
                  color: "rgba(0, 144, 255,0.1)"
                }
              ],
              false
            ),
            shadowColor: "rgba(0, 144, 255,0.1)",
            shadowBlur: 10
          }
        },
        data: data20
      },
      {
        name: "30CM",
        type: "line",
        smooth: true, //是否平滑
        showAllSymbol: true,
        // symbol: 'image://./static/images/guang-circle.png',
        symbol: "circle",
        symbolSize: 0,
        lineStyle: {
          normal: {
            color: "rgb(14,156,255)",
            shadowColor: "rgba(0, 0, 0, 0)",
            shadowBlur: 0,
            shadowOffsetY: 5,
            shadowOffsetX: 5
          }
        },
        label: {
          show: false,
          position: "top",
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        itemStyle: {
          color: "rgb(14,156,255)",
          borderColor: "rgb(255,115,100)",
          borderWidth: 0,
          shadowColor: "rgba(0, 0, 0, 0)",
          shadowBlur: 0,
          shadowOffsetY: 0,
          shadowOffsetX: 0
        },
        tooltip: {
          show: true
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(0, 144, 255, 0.3)"
                },
                {
                  offset: 1,
                  color: "rgba(0, 144, 255,0.1)"
                }
              ],
              false
            ),
            shadowColor: "rgba(0, 144, 255,0.1)",
            shadowBlur: 10
          }
        },
        data: data30
      }
    ]
  });
}
